/* eslint-disable */
export const baseUrl = window.location.hostname === 'localhost' ? '/api' : 'https://api.my-lawcloud.com'
export default async (url = '', data = {}, type = 'GET', method = 'fetch') => {
	type = type.toUpperCase();
	url = baseUrl + url;

	if (type == 'GET') {
		let dataStr = ''; //数据拼接字符串
		Object.keys(data).forEach(key => {
			dataStr += key + '=' + data[key] + '&';
		})

		if (dataStr !== '') {
			dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
			url = url + '?' + dataStr;
		}
  }
  
  let token = window.localStorage.getItem('token')
  if (type == 'UPLOAD') {
    const fd = new FormData()
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const element = data[key]
        fd.append(key, element)
      }
    }
    if (window.fetch ) {
      let requestConfig = {
        method: 'POST',
        body: fd,
        headers: {
        }
      }
      if (token) {
        requestConfig.headers['Authorization'] = token
      }
      try {
        const response = await fetch(url, requestConfig,);
        const responseJson = await response.json();
        return responseJson
      } catch (error) {
        throw new Error(error)
      }
    } else {
      return new Promise((resolve, reject) => {
        let requestObj;
        if (window.XMLHttpRequest) {
          requestObj = new XMLHttpRequest();
        } else {
          requestObj = new ActiveXObject;
        }
  
        requestObj.send(fd)
        requestObj.open('POST', url, true);
        if (token) {
          requestObj.setRequestHeader('Authorization', token)
        }
        requestObj.send(sendData);
  
        requestObj.onreadystatechange = () => {
          if (requestObj.readyState == 4) {
            if (requestObj.status == 200) {
              let obj = requestObj.response
              if (typeof obj !== 'object') {
                obj = JSON.parse(obj);
              }
              resolve(obj)
            } else {
              reject(requestObj)
            }
          }
        }
      })
    }
  } else {
    if (window.fetch && method == 'fetch') {
      let requestConfig = {
        credentials: 'include',
        method: type,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        mode: "cors"
      }
      
      
      if (token) {
        requestConfig.headers['Authorization'] = token
      }
  
      if (type == 'POST') {
        Object.defineProperty(requestConfig, 'body', {
          value: JSON.stringify(data)
        })
      }
      
      try {
        const response = await fetch(url, requestConfig);
        const responseJson = await response.json();
        return responseJson
      } catch (error) {
        throw new Error(error)
      }
    } else {
      return new Promise((resolve, reject) => {
        let requestObj;
        if (window.XMLHttpRequest) {
          requestObj = new XMLHttpRequest();
        } else {
          requestObj = new ActiveXObject;
        }
  
        let sendData = '';
        if (type == 'POST') {
          sendData = JSON.stringify(data);
        }
  
        requestObj.open(type, url, true);
        requestObj.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        if (token) {
          requestObj.setRequestHeader('Authorization', token)
        }
        requestObj.send(sendData);
  
        requestObj.onreadystatechange = () => {
          if (requestObj.readyState == 4) {
            if (requestObj.status == 200) {
              let obj = requestObj.response
              if (typeof obj !== 'object') {
                obj = JSON.parse(obj);
              }
              resolve(obj)
            } else {
              reject(requestObj)
            }
          }
        }
      })
    }
  }
}
